import React, { useState } from 'react';
import { Animated, Image, StyleSheet } from 'react-native';

import Images from '../../state/stores/Image/images';
import { COLORS } from '../../config/designSystem/Colors';
import { H1, ParagraphMRegular, Subtitle2 } from '../../config/designSystem/typography';
import { animate } from '../../utils/breathe/animate';
import { isAndroid } from '../../config/designSystem/Layout';
import { observer } from 'mobx-react';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useOnMount } from '../../hooks/useOnMount';
import { useStores } from '../../hooks/useStores';


const mountAnimDuration = 400;
const unmountAnimDuration = 400;

export const ExerciceComplete =  observer(() => {
  const [mountAnimVal] = useState(new Animated.Value(0));
  const rootStore = useStores();
  const labels = rootStore?.language?.translate?.MOBILE?.SNACKING?.BREATHE;
  const technique = rootStore.technique.getTechnique;
  const {width} = useAvailableDimensions();
  const duration = rootStore?.technique?.getTimerDuration;

  const mountAnimation = animate(mountAnimVal, {
    toValue: 1,
    duration: mountAnimDuration,
  });

  const unmountAnimation = animate(mountAnimVal, {
    toValue: 0,
    duration: unmountAnimDuration,
  });

  useOnMount(() => {
    mountAnimation.start();
    return () => {
      mountAnimation.stop();
      unmountAnimation.stop();
    };
  });

  const containerAnimatedStyle = {
    opacity: mountAnimVal.interpolate({
      inputRange: [0, 1],
      outputRange: [0, 1],
    }),
  };

  const ICON_DIMENSION = 16;

  return (
    <Animated.View style={[styles.container,containerAnimatedStyle,  !isAndroid && { zIndex:-1}, isAndroid && {zIndex:1}]}>
      <Animated.View style={{width: 0.7*width, maxWidth: 600, alignItems: 'center', rowGap: 20}}>
        <Animated.View>
          <Subtitle2 color={COLORS.brand[500] } align={true}>
            {(labels?.PATTERN ? labels?.PATTERN + ': ' : '') + technique.durations.join('-')}
          </Subtitle2>
        </Animated.View>
        <Animated.View>
          <H1 align={true}>
            {labels?.SESSION_COMPLETED ? labels?.SESSION_COMPLETED : 'Session completed'}
          </H1>
        </Animated.View>
        <Animated.View style={{flexDirection:'row', justifyContent:'center', alignItems: 'center', columnGap: 20}}>
          <Animated.View style={{width: ICON_DIMENSION, height: ICON_DIMENSION}}>
            <Image
              style={[{ width: ICON_DIMENSION, height: ICON_DIMENSION }]}
              source={Images.breathe.times}
              width={ICON_DIMENSION}
              height={ICON_DIMENSION}
            />
          </Animated.View>
          <Animated.View style={{justifyContent:'center', alignItems: 'center'}}>
            <ParagraphMRegular >
              {duration + ' ' + (labels?.MIN?labels.MIN:'min')}
            </ParagraphMRegular>
          </Animated.View>
        </Animated.View>
      </Animated.View>
    </Animated.View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  }
});